import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Dynamic redux
export const reduxModuleLoaded = createAction(`${actionKey}.REDUX_READY`, ()=>({}));
export const initialize = createAction(`${actionKey}.INITIALIZE`, ({ deviationId })=>({
        deviationId
    }));
export const deinitialize = createAction(`${actionKey}.DEINITIALIZE`, ()=>({}));
export const initializeSuccess = createAction(`${actionKey}.INITIALIZE_SUCCESS`, (payload)=>payload);
export const initializeTierTags = createAction(`${actionKey}.INITIALIZE_TIER_TAGS`, (payload)=>payload);
export const initializeTierTagsSuccess = createAction(`${actionKey}.INITIALIZE_TIER_TAGS_SUCCESS`, (payload)=>payload);
export const deleteDeviation = createAction(`${actionKey}.DELETE_DEVIATION`, (deviation)=>({
        deviation
    }));
export const submitDeviation = createAction(`${actionKey}.SUBMIT_DEVIATION`, (payload)=>payload);
export const deviationSaveError = createAction(`${actionKey}.DEVIATION_SAVE_ERROR`, (message)=>({
        message
    }));
